import {
  computed,
  useStore,
  defineAsyncComponent,
  ComputedRef,
} from '@nuxtjs/composition-api'
import { getRegistryComponents, Registry, registry } from '../helpers/registry'

export const useRegistry = (): ComputedRef<Record<Registry, any>> => {
  const store = useStore()

  return computed<Record<keyof Registry, any>>(() => {
    const components = getRegistryComponents(store)
    const result = {}
    Object.keys(registry).forEach((key) => {
      result[key] = defineAsyncComponent({
        loader: components[key],
      })
    })

    return result
  })
}
